export const initialState = {
  availableTimeGaps: ['day', 'hour'],
  bulletinAvailableTimeGaps: ['day', 'hour'],
  brandBaanAvailableTimeGaps: ['week', 'day'],
  resourceProfile: {
    twitter: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
    },
    virasty: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'hour',
      batchPublishProcess: 'hour',
    },
    news: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
    telegram: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
    },
    instagram: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
    },
    instagramComment: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
    nativePlatforms: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
    eitaa: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
    bale: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
    rubika: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
    linkedin: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
    },
  },
  statistics: {
    twitter: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    virasty: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    news: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    telegram: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    instagram: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    instagramComment: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    nativePlatforms: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    eitaa: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    bale: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    rubika: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
    linkedin: {
      postsPublishSpeed: 'hour',
      postsPublishProcess: 'hour',
      nssTrend: 'day',
      batchPublishProcess: 'hour',
      hashtagFilterQuery: false,
      wordFilterQuery: false,
    },
  },
  comparisonResource: {
    allPlatforms: {
      postsPublishProcess: 'hour',
    },
  },
  comparisonSubject: {
    allPlatforms: {
      postsPublishProcess: 'hour',
    },
  },
  bulletinPDF: {
    twitter: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    virasty: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    news: {
      postsPublishProcess: 'hour',
    },
    telegram: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    instagram: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    nativePlatforms: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    eitaa: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    bale: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
    rubika: {
      postsPublishProcess: 'hour',
      batchPublishProcess: 'hour',
    },
  },
  brandBaan: {
    allPlatforms: {
      voiceTrendTimeGap: 'day',
      nssTrendTimeGap: 'day',
      storyPublicationComparison: 'day',
    },
  },
};
